<template>
    <div class="input-group">
        <span class="input-group-btn"><button type="button" class="btn input-lg" @click="minus()"><span class="glyphicon glyphicon-minus"></span></button></span>
        <label style="background-color: #F3F2EE; color: #66615b;" type="text" class="form-control input-lg text-center"  readonly="readonly">{{counterLabel}}</label>
        <input type="hidden" :name="name" v-model="count" />
        <span class="input-group-btn" @click="plus()"><button type="button" class="btn input-lg"><span class="glyphicon glyphicon-plus"></span></button></span>
    </div>
</template>

<script>

    import { EventBus } from '../event-bus'

    export default {
        data() {
            return { counter: 0 }
        },

        mounted() {
            return this.counter = parseInt(this.count);
        },
        computed : {
            counterLabel() {
                return this.counter + ' ' + this.word;
            }
        },
        watch: {
            count: function(count) {
                this.counter = count
                EventBus.$emit('headCountChanged', this.counter)
            }
        },
        props: {
            'name':{
                        type: String,
                        required: true
                    },
            'count':{
                        type: Number,
                        required: true
                    },
            'min':{
                        type: Number,
                        required: true
                    },
            'max':{
                        type: Number,
                        required: true
                    },
            'step':{
                        type: Number,
                        default: 1
                    },
            'word': {
                        type: String,
                        required: true
                    }
         },

        methods: {
            plus() {
                this.counter = this.counter + parseInt(this.step);
                if (this.counter >= this.max) {
                    this.counter = this.max;
                }
                EventBus.$emit('headCountChanged', this.counter)
            },

            minus() {
                this.counter = this.counter - parseInt(this.step);
                if (this.counter <= this.min) {
                    this.counter = this.min;
                }
                EventBus.$emit('headCountChanged', this.counter)
            }
        }
    }
</script>

`

             `